import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const UsersLegacyTableColumns: ITableColumn[] = [
  {
    labelPath: '',
    propertyKey: 'pictureUrl',
    colType: TableColumnTypeEnum.Icon,
    width: 30,
    iconBorder: true,
    widthType: WidthType.Pixel,
    tooltipDynamicText: 'invitationDesc',
  },
  {
    labelPath: 'userManagementPage.usersPage.tableColumns.name',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'userManagementPage.usersPage.tableColumns.email',
    propertyKey: 'email',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'userManagementPage.usersPage.tableColumns.createdAt',
    propertyKey: 'createdAt',
    colType: TableColumnTypeEnum.Date,
    width: 180,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'userManagementPage.usersPage.tableColumns.lastLogin',
    propertyKey: 'lastLogin',
    colType: TableColumnTypeEnum.Date,
    width: 180,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'userManagementPage.usersPage.tableColumns.role',
    propertyKey: 'role',
    colType: TableColumnTypeEnum.DropDownOptions,
    width: 180,
    widthType: WidthType.Pixel,
    toCapitalize: true,
  },
];
